import { MyLayeredBarChart } from '@interstellar-component'

import { useDashboard } from '../Context'

// KOL 1..5 → green → yellow → orange → light-red → red.
// Same intent as the table badge palette (getBadgeColor) so the chart legend
// and the row badges read as the same scale.
const CHART_COLORS = ['#17B26A', '#F5A524', '#F38744', '#F04438', '#B42318']

function ChartCard({ title, subtitle, series, labels }) {
  return (
    <div className="flex-1 min-w-0 rounded-xl border border-gray-light/200 bg-white p-6 shadow-sm flex flex-col gap-6">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <p className="text-sm text-gray-600">{subtitle}</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-end gap-3 text-xs font-medium text-gray-500">
        {series.map((s, i) => (
          <div key={s.name} className="flex items-center gap-1.5">
            <span
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: CHART_COLORS[i % CHART_COLORS.length] }}
            />
            {s.name}
          </div>
        ))}
      </div>

      <div className="h-[240px] w-full">
        <MyLayeredBarChart
          series={series}
          colors={CHART_COLORS}
          labels={labels}
          height={240}
        />
      </div>
    </div>
  )
}

function KolektibilitasSection() {
  const { employeeSeries, candidateSeries, chartLabels } = useDashboard()

  return (
    <div className="flex w-full flex-col gap-6 p-8 pb-0">
      <div className="flex flex-col gap-1">
        <h2 className="text-[18px] font-semibold text-gray-900">Collectability</h2>
        <p className="text-[14px] text-gray-600">
          Manage your team members and their account permissions here.
        </p>
      </div>

      <div className="flex flex-col gap-6 md:flex-row">
        <ChartCard
          title="Employee"
          subtitle="Track how your rating compares to your industry average."
          series={employeeSeries || []}
          labels={chartLabels}
        />
        <ChartCard
          title="Candidate interview"
          subtitle="Track how your rating compares to your industry average."
          series={candidateSeries || []}
          labels={chartLabels}
        />
      </div>
    </div>
  )
}

export default KolektibilitasSection
